import { render, staticRenderFns } from "./LinkedAccounts.vue?vue&type=template&id=cc4c9466&scoped=true"
import script from "./LinkedAccounts.vue?vue&type=script&lang=ts"
export * from "./LinkedAccounts.vue?vue&type=script&lang=ts"
import style0 from "./LinkedAccounts.vue?vue&type=style&index=0&id=cc4c9466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4c9466",
  null
  
)

export default component.exports